// extracted by mini-css-extract-plugin
module.exports = {"container":"lYCPtCaE-XXLIL4F9pdX4"};